import styled from '@emotion/styled';
import type { MicrositeVideoData } from '~/model';
import MicrositeVideo from '~/components/MicrositeVideo';

const Section = styled.section`
	padding: 3rem 1.5rem 4rem;
`;

const Title = styled.h2`
	font-size: 2rem;
	text-transform: uppercase;
	letter-spacing: 0.2em;
	margin-bottom: 1.5rem;
`;

const Player = styled.div`
	width: 100%;
	aspect-ratio: 16 / 9;
	background: black;
`;

export default function VideoBlockDelta({ title, video }: { title: string; video: MicrositeVideoData }) {
	return (
		<Section id="showcase">
			<Title>{title}</Title>
			<Player>
				<MicrositeVideo video={video} />
			</Player>
		</Section>
	);
}
